import React from 'react';

// Mane Logo — 3D chrome M (generated by Ideogram)
export default function ManeLogo({ size = 36, showWordmark = true, dark = false }) {
  const wordColor = dark ? '#0a0a0a' : '#ffffff';
  const gap = size * 0.35;
  const wordSize = size * 0.58;

  const icon = (
    <img
      src="/mane-lion-logo.png"
      alt="Mane"
      style={{
        width: size,
        height: size,
        display: 'block',
        objectFit: 'contain',
        
      }}
    />
  );

  if (!showWordmark) return icon;

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap }}>
      {icon}
      <span style={{
        fontFamily: "'Inter','SF Pro Display',-apple-system,sans-serif",
        fontSize: wordSize,
        fontWeight: 800,
        letterSpacing: '0.08em',
        color: wordColor,
        lineHeight: 1,
        paddingRight: '0.08em',
      }}>
        MANE
      </span>
    </div>
  );
}
